/**
 * Green Flag — Input recipe
 *
 * Applied to the Input component. Green Flag's only input-like surface is the
 * Search bar — a soft-stroked pill with an icon inside. Kept minimal until
 * additional form fields are designed.
 */

import { defineRecipe } from "@chakra-ui/react";

export const inputRecipe = defineRecipe({
  className: "gf-input",

  base: {
    fontFamily: "body",
    fontSize: "md",
    color: "fg.default",
    bg: "bg.canvas",
    border: "1px solid",
    borderColor: "border.subtle",
    transitionProperty: "border-color, box-shadow",
    transitionDuration: "normal",
    _placeholder: { color: "fg.muted", opacity: 0.65 },
    _focusVisible: {
      outline: "none",
      borderColor: "border.brand",
      boxShadow: "focusRing",
    },
  },

  variants: {
    visual: {
      search: {
        h: "29px",
        px: "3",
        borderRadius: "pill",
      },
      outline: {
        h: "40px",
        px: "4",
        borderRadius: "sm",
      },
    },
  },

  defaultVariants: {
    visual: "search",
  },
});
